import { useTableFooter } from './hooks';
import { TableFooterPresentation } from './presentations';

type Props = {
  itemCount: number;
  totalCount: number;
  totalPage: number;
  onPageChange: (page: number) => void;
};

/**
 * テーブルのFooterコンポーネント
 *
 * @param itemCount 1ページに表示するアイテム数
 * @param totalCount 総アイテム数
 * @param totalPage 総ページ数
 * @param handlePageChange ページ変更ハンドラー
 */
export const TableFooter: React.FC<Props> = ({
  itemCount,
  totalCount,
  totalPage,
  onPageChange,
}) => {
  const {
    data: { currentPage },
    actions: {
      handleFirstPageButtonClick,
      handleBackButtonClick,
      handleNextButtonClick,
      handleLastPageButtonClick,
    },
  } = useTableFooter({ totalPage, onPageChange });

  return (
    <TableFooterPresentation
      itemCount={itemCount}
      totalCount={totalCount}
      currentPage={currentPage}
      totalPage={totalPage}
      handleFirstPageButtonClick={handleFirstPageButtonClick}
      handleBackButtonClick={handleBackButtonClick}
      handleNextButtonClick={handleNextButtonClick}
      handleLastPageButtonClick={handleLastPageButtonClick}
    />
  );
};
